var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_3911)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58618 1.79329C9.60608 1.79329 9.62598 1.79329 9.64588 1.79329C11.8515 1.79329 13.9317 2.68488 15.51 4.30588C17.1081 5.94778 17.9962 8.13698 18.0121 10.47C18.0464 15.2897 14.3193 19.2387 9.70359 19.2725C7.48206 19.2934 5.37296 18.3983 3.78032 16.7614C2.1832 15.12 1.29409 12.9298 1.27767 10.5944C1.24483 5.77563 4.97244 1.82762 9.58618 1.79329ZM9.64041 20.1825C9.6638 20.1825 9.68768 20.1825 9.71106 20.182C14.8273 20.1447 18.9594 15.7852 18.9216 10.4635C18.9052 7.89418 17.9245 5.48258 16.1622 3.67151C14.395 1.85548 12.053 0.866361 9.57921 0.884272C4.46445 0.921588 0.331837 5.28008 0.368158 10.6008C0.386069 13.1721 1.36673 15.5852 3.12854 17.3963C4.8789 19.1949 7.18901 20.1825 9.64041 20.1825Z",
    fill: "#ADB84E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08592 9.18438L4.45042 7.60189L6.54357 5.43861L9.66618 8.46L12.8139 5.20688L14.8634 7.19L11.7157 10.4431L14.8387 13.4649L12.7456 15.6281L9.6226 12.6064L6.47355 15.861L4.42399 13.8778L7.57304 10.6233L6.08592 9.18438ZM3.13756 13.8994L6.49475 17.1477L9.64381 13.8932L12.7668 16.9149L16.1258 13.4433L13.0029 10.4216L16.1498 7.16916L12.7927 3.9208L9.64568 7.17322L6.52306 4.15183L3.16401 7.62343L6.28663 10.6448L3.13756 13.8994Z",
    fill: "#ADB84E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_3911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.4043,
    height: 19.4043,
    fill: "white",
    transform: "translate(0 0.808594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.293150a74646c72c01832fb63546e84a.svg";
export { ForwardRef as ReactComponent };